<template>
    <div style="display:flex">
      |<div v-for="(m, index) in measure" :key="index" style="display:flex">
        <div v-for="(n, index) in m.note" :key="index">
          <Note :noteName="noteToSolfegeMap[n.pitch.step]" :width="10" :height="10" :uppderDot="true" :duration="n.pitch.duration"/>
          <Note v-if="n.duration === '2'" noteName="0" :width="10" :height="10" :isBar="true" />
        </div>|
      </div>
      <router-link to="/">Do Re Mi Fa</router-link> | <button @click="goBack">go back one step</button>
    </div>
</template>

<script>
// import myScore from '@/data/score.js'
import myScore from '@/data/little_star.js'
// eslint-disable-next-line no-unused-vars
import Note from '@/components/Note.vue'
import { mapState } from 'vuex'

// eslint-disable-next-line no-unused-vars
const noteToSolfegeMap = {
  C: 1,
  D: 2,
  E: 3,
  F: 4,
  G: 5,
  A: 6,
  B: 7
}

export default {
  name: 'Score',
  components: {
    Note
  },
  data () {
    return {
      myScore,
      noteToSolfegeMap,
      part: [],
      measure: []
    }
  },
  methods: {
    goBack () {
      // eslint-disable-next-line no-debugger
      debugger
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapState([
    ])
  },
  mounted () {
    console.dir(myScore)

    // var part = myScore['score-partwise'].part
    var part = myScore.part
    this.part.push(part)
    this.measure = part.measure
  }
}
</script>
